module.exports = __webpack_public_path__ + "img/icon_call_gray.304dc367.svg";